var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExplorerTab(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7493 28.3307H22.3142V18.9881H17.7493V28.3307ZM18.8049 19.9974H21.2586V27.2474H18.8049V19.9974ZM23.7586 15.6363V28.3307H28.3327V15.6733L23.7586 15.6363ZM27.2771 27.2474H24.8142V16.7104H27.2771V27.2474ZM11.7308 28.3307H16.3049V21.34H11.7308V28.3307ZM12.7771 22.377H15.2493V27.2844H12.7771V22.377ZM19.3882 11.6641L23.0919 12.377L22.379 16.0807L21.3419 15.8863L21.7216 13.9048L12.2216 19.7567L11.666 18.8307L21.1105 13.053L19.1845 12.6918L19.3882 11.6641Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExplorerTab);
export default __webpack_public_path__ + "static/media/explorerTab.0002d72c9b5b319b438c1be11be93054.svg";
export { ForwardRef as ReactComponent };